import { PopupContainer } from "../Popup/PopupContainer";
/**
 * メニューコンテナコンポーネント。
 */
export var MenuContainer = PopupContainer;
